



















































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import pdf from 'vue-pdf';
import panzoom from 'panzoom';

@Component({
  components: {
    pdf
  }
})
export default class PDFViewer extends Vue {

  @Prop({default: {}}) selectedItem!: {
    title: string;
    pdf: string;
  };
  @Prop({ default: () => []}) selectedPDFs!: object[];

  src = '';
  loadedRatio = 0;
  page = 1;
  numPages = 0;
  rotate = 0;
  showPDFHeader = true;
  open = false;
  overlay = false;
  fullheight = true;
  show = true;

  @Watch('page')
  pageNumber(newVal) {
    if (newVal === '' || newVal < 0) {
      newVal = 0;
    }
    this.page = newVal;
  }



  error() {
    if (this.page < 0) {
      this.page = Math.abs(this.page)
      this.$buefy.snackbar.open({
        message: this.$t('pdfNoPages') as string,
        type: 'is-primary',
        position: 'is-top',
        actionText: 'Ok',
        indefinite: true,
        onAction: () => {
          this.page = 1;
          this.$buefy.toast.open({
            message: this.$t('backToDefaultPage') as string,
            queue: false
          })
        }
      })
      return;
    }

  }

  hideHeader() {
    this.showPDFHeader = false;
  }

  showHeader() {
    this.showPDFHeader = true;
  }

  previous() {
    --this.page;
  }

  next() {
    ++this.page;
  }

  onPDFLoad() {
    panzoom(this.$refs.pdfBlock as HTMLElement)
  }

  showPDF(item) {
    this.selectedItem.pdf = item.pdf
    this.open = false;
  }

  showPDFMenu() {
    this.open = true;
  }

  closePDFMenu() {
    this.open = false;
  }

  downloadPDF () {
    const aLink = document.createElement('a');
    aLink.href = `/products/pdf/${this.selectedItem.pdf}`
    aLink.download = `/products/pdf/${this.selectedItem.pdf}`;
    aLink.click();
  }

}
